import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave, FaAngleLeft } from "react-icons/fa";
import LeaseApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import moment from 'moment';
import { ClipLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';
import WindowedSelect from 'react-windowed-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from 'react-redux';
import { getUserName } from '../../../Redux/selecters';
const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const LeaseReceipt = () => {
    const [dataList, setDataList] = useState([]);
    const [unAllocatedAmounts, setUnAloocated] = useState();
    const [alocatedAmounts, setAloocated] = useState();
    const [leaseLIst, setLeaseList] = useState([]);
    const [FilterTab, setFilterTab] = useState(true);
    const [PaymentTab, setPaymentTab] = useState(true);
    const [loader, setLoader] = useState(false);
    const [transTab, setTransTab] = useState(true);
    const [sendEmail, setSendEmail] = useState(false);
    const [methods, setMethods] = useState([]);
    const [receiptType, setreceiptType] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [additional, setAdditional] = useState([]);
    const [debitAccount, setDebitAccount] = useState([]);
    const [leaseNo, setLeaseNo] = useState([]);
    const [property, setProperty] = useState([]);
    const apiService = new LeaseApiService();
    const navigate = useNavigate();
    const Name = useSelector(getUserName);

    // const currentDatetimeUTC = new Date().toISOString();
    const currentDatetimeUTC = new Date().toISOString().split('T')[0];
    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    };
    const [transDetail, setTransDetail] = useState({
        transMethod: [],
        receiptType: [],
        checkNo: "",
        receiptDate: getCurrentLocalDatetime(),
        // checkDate: getCurrentLocalDatetime(),
        checkDate: '01/01/1900',
        amount: 0,
        drawnBank: "",
        accountDr: [],
        reserveNo: "",
        payee: "",
        narration: "",
    });
    const [leaseDetails, setLeaseDetail] = useState({
        leaseNo: [],
        property: [],
        unitNo: [],
        periodfrom: "",
        periodto: "",
        rent: "",
        TenantNo: "",
        TenantName: "",
        contactNo: "",
    });
    const [accountdata, setAccountData] = useState({
        accountNO: [],
        amount: 0,
        refNo: "",
        allocated: 0,
        unAllocated: 0,
    });
    useEffect(() => {
        getUserList()
    }, []);
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const getUserList = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'PaymentMethod,ReceiptType,AdditionalAccounts,DebitAccounts,ReceiptLeaseNos,ReceiptPropertyNos');
            const customerRes = await apiService.getApiParamater('RECEIPT_DROPDOWN', `?${params.toString()}`);
            setMethods(customerRes?.data?.dropdowns?.PaymentMethod);
            setreceiptType(customerRes?.data?.dropdowns?.ReceiptType);
            setAdditional(customerRes?.data?.dropdowns?.AdditionalAccounts);
            setDebitAccount(customerRes?.data?.dropdowns?.DebitAccounts);
            setProperty(customerRes?.data?.dropdowns?.PropertyNo);
            setLeaseNo(customerRes?.data?.dropdowns?.LeaseNo);
            const selecteddabit = customerRes?.data?.dropdowns?.PaymentMethod?.find(pro => pro?.text === "Bank Transfer");
            const selectedLease = customerRes?.data?.dropdowns?.ReceiptType?.find(pro => pro?.text === "Lease Receipt");
            setTransDetail({
                ...transDetail,
                transMethod: { label: selecteddabit?.text, value: selecteddabit },
                receiptType: { label: selectedLease?.text, value: selectedLease },
            });
        } catch (error) {
            console.error('Error fetching data:', error?.customerRes?.data?.message);
        }
    }
    const handleBackClick = () => {
        window.history.back();
    };
    const handleEmailChange = () => {
        setSendEmail(!sendEmail);
    };
    const handleMethodChange = async (selectedOption) => {
        if (selectedOption?.label) {
            setTransDetail({ ...transDetail, accountDr: {} });
            const Casparams = new URLSearchParams();
            Casparams.append('DropdownFor', 'LRDebitAccounts');
            Casparams.append('CascadValue', selectedOption?.label);
            const casres = await apiService.getApiParamater('CASCAD_DROP', `?${Casparams.toString()}`);
            setDebitAccount(casres?.data?.items)
            setTransDetail({
                ...transDetail,
                transMethod: selectedOption,
                accountDr: [{ label: '', value: '' }],
            });

        }
    }
    const handleTypeChange = async (selectedOption) => {
        setTransDetail({ ...transDetail, receiptType: selectedOption });
    }
    const handleAccountChange = (selectedOption) => {
        setTransDetail({ ...transDetail, accountDr: selectedOption });
    }
    const handleLeaseNoChange = async (selectedOption) => {

        const params = new URLSearchParams();
        params.append('Action', 'GetCustomerDetailsByLeaseNo');
        params.append('LeaseNo', selectedOption?.label);
        const res = await apiService.getApiParamater('LEASE_NO_DATA', `?${params.toString()}`);
        let data = res?.data?.result?.data
        const selectedpaymentTerm = property?.find(pro => pro?.value === data?.Property_No);
        handleClear()
        setLeaseDetail(prev => ({
            unitNo: [{ label: null, value: null }],
            property: [{ label: null, value: null }],
        }));

        if (selectedpaymentTerm) {
            const Casparams = new URLSearchParams();
            Casparams.append('DropdownFor', 'LRUnitNosByPropertyId');
            Casparams.append('CascadValue', selectedpaymentTerm?.value);
            const casres = await apiService.getApiParamater('CASCAD_DROP', `?${Casparams.toString()}`);
            setUnitList(casres?.data?.items)
            const selectedUnit = casres?.data?.items?.find(pro => pro?.value === data?.Unit_No);
            setLeaseDetail({
                ...leaseDetails,
                leaseNo: selectedOption,
                property: { label: selectedpaymentTerm?.text, value: selectedpaymentTerm },
                unitNo: { label: selectedUnit?.value, value: selectedUnit },
                periodfrom: data?.PeriodFrom,
                periodto: data?.PeriodTo,
                rent: data?.Rent,
                TenantName: data?.TenantName,
                TenantNo: data?.TenantNo,
                contactNo: data?.ContactNo,
                EmailId: data?.EmailId,
                Group_Id: data?.Group_Id,
                Property_No: data?.Property_No,
                Status: data?.Status,
                Unit_No: data?.Unit_No,
            });

            const tableparams = new URLSearchParams();
            tableparams.append('Action', 'GetReceviablesByLeaseNo');
            tableparams.append('LeaseNo', selectedOption?.label);
            const TableRes = await apiService.getApiParamater('LEASE_NO_DATA', `?${tableparams.toString()}`);
            let tabledata = TableRes?.data?.result?.data
            if (tabledata?.length > 0) {
                setLeaseList(tabledata)
                setDataList(initializeDataList(tabledata));
            } else {
                setLeaseList([tabledata])
                setDataList(initializeDataList([tabledata]));
            }

            const dabitparam = new URLSearchParams();
            dabitparam.append('Action', 'GetDrAccCodeByPropNo');
            dabitparam.append('PropertyNo', data?.Property_No);
            const dabitRes = await apiService.getApiParamater('LEASE_NO_DATA', `?${dabitparam.toString()}`);
            let dabitData = dabitRes?.data?.result?.data
            const selecteddabit = debitAccount?.find(pro => pro?.text === dabitData?.DrAccName);
            setTransDetail({
                ...transDetail,
                accountDr: { label: selecteddabit?.text, value: selecteddabit },
            });
            setAccountData(prev => ({
                ...prev,
                unAllocated: transDetail?.amount || 0,
                allocated: 0,
                amount: 0,
            }));
            setAloocated(0)
            setUnAloocated(transDetail?.amount || 0)
        }
    }
    const handlePropertyNoChange = async (selectedOption) => {
        handleClear()
        const params = new URLSearchParams();
        params.append('DropdownFor', 'LRUnitNosByPropertyId');
        params.append('CascadValue', selectedOption?.value?.value);
        const res = await apiService.getApiParamater('CASCAD_DROP', `?${params.toString()}`);
        setUnitList(res?.data?.items)
        setLeaseDetail({
            ...setLeaseDetail,
            property: selectedOption,
            leaseNo: [{ label: '', value: '' }],
            unitNo: [{ label: '', value: '' }],
            periodfrom: "",
            periodto: "",
            rent: "",
            TenantNo: "",
            TenantName: "",
            contactNo: "",
        });
        setAccountData(prev => ({
            ...prev,
            unAllocated: transDetail?.amount || 0,
            allocated: 0,
            amount: 0,
        }));
        setAloocated(0)
        setUnAloocated(transDetail?.amount || 0)
    }
    const handleUnitNoChange = async (selectedOption) => {
        handleClear()
        const selectedUnit = leaseNo?.find(pro => pro?.text === selectedOption?.value?.text);
        const params = new URLSearchParams();
        params.append('Action', 'GetCustomerDetailsByLeaseNo');
        params.append('LeaseNo', selectedUnit?.text);
        const res = await apiService.getApiParamater('LEASE_NO_DATA', `?${params.toString()}`);
        let data = res?.data?.result?.data
        setLeaseDetail({
            ...leaseDetails,
            unitNo: selectedOption,
            leaseNo: { label: selectedUnit?.text, value: selectedUnit },
            periodfrom: data?.PeriodFrom,
            periodto: data?.PeriodTo,
            rent: data?.Rent,
            TenantName: data?.TenantName,
            TenantNo: data?.TenantNo,
            contactNo: data?.ContactNo,
            EmailId: data?.EmailId,
            Group_Id: data?.Group_Id,
            Property_No: data?.Property_No,
            Status: data?.Status,
            Unit_No: data?.Unit_No,
        });

        const tableparams = new URLSearchParams();
        tableparams.append('Action', 'GetReceviablesByLeaseNo');
        tableparams.append('LeaseNo', selectedUnit?.text);
        const TableRes = await apiService.getApiParamater('LEASE_NO_DATA', `?${tableparams.toString()}`);
        let tabledata = TableRes?.data?.result?.data
        if (tabledata?.length > 0) {
            setLeaseList(tabledata)
            setDataList(initializeDataList(tabledata));
        } else {
            setLeaseList([tabledata])
            setDataList(initializeDataList([tabledata]));
        }

        const dabitparam = new URLSearchParams();
        dabitparam.append('Action', 'GetDrAccCodeByPropNo');
        dabitparam.append('PropertyNo', leaseDetails?.property?.value?.value);
        const dabitRes = await apiService.getApiParamater('LEASE_NO_DATA', `?${dabitparam.toString()}`);
        let dabitData = dabitRes?.data?.result?.data
        const selecteddabit = debitAccount?.find(pro => pro?.text === dabitData?.DrAccName);
        setTransDetail({
            ...transDetail,
            accountDr: { label: selecteddabit?.text, value: selecteddabit },
        });
        setAccountData(prev => ({
            ...prev,
            unAllocated: transDetail?.amount || 0,
            allocated: 0,
            amount: 0,
        }));
        setAloocated(0)
        setUnAloocated(transDetail?.amount || 0)
    }
    const handleSelectChange = (e, index) => {
        const updatedList = [...dataList];
        const checked = e.target.checked;
        let { unAllocated, allocated } = accountdata;
        unAllocated = parseFloat(unAllocated) || 0;
        allocated = parseFloat(allocated) || 0;
        let amountvle = parseFloat(accountdata?.amount || 0);

        const record = updatedList[index];
        const balance = parseFloat(record.Balance) || 0;
        const amount = parseFloat(record.amount) || 0;

        if (checked) {
            if (unAllocated === 0) {
                toast.warn("Not enough unAllocated amount available.");
                return;
            }

            let allocatableAmount = Math.min(unAllocated, balance);
            record.amount = allocatableAmount;
            record.Balance = balance - allocatableAmount;
            record.IsSelected = true;

            const newAllocated = allocated + allocatableAmount;
            const newUnallocated = unAllocated - allocatableAmount;

            setAloocated(newAllocated - amountvle);
            setUnAloocated(newUnallocated + amountvle);
            setAccountData(prev => ({
                ...prev,
                allocated: newAllocated - amountvle,
                unAllocated: newUnallocated + amountvle,
                amount: 0
            }));

        } else {
            // If unchecked, reverse the allocation
            const reverseAmount = parseFloat(record.amount) || 0;
            record.amount = 0;
            record.Balance = balance + reverseAmount;
            record.IsSelected = false;

            const newAllocated = allocated - reverseAmount;
            const newUnallocated = unAllocated + reverseAmount;

            setAloocated(newAllocated - amountvle);
            setUnAloocated(newUnallocated + amountvle);
            setAccountData(prev => ({
                ...prev,
                allocated: newAllocated - amountvle,
                unAllocated: newUnallocated + amountvle,
                amount: 0
            }));
        }

        setDataList(updatedList);
    }

    const handleInputChange = (e) => {

        const { name, value } = e.target;

        if (name === "amount") {

            const numericValue = parseFloat(value) || 0;
            // Update transaction and account states
            setTransDetail({ ...transDetail, [name]: numericValue });
            setAccountData(prev => ({
                ...prev,
                unAllocated: numericValue || 0,
                allocated: 0,
                amount: 0,
            }));
            setAloocated(0);
            setUnAloocated(numericValue || 0);

            // If value matches condition, unselect all items
            const updatedList = leaseLIst?.map(item => ({
                ...item,
                IsSelected: false
            }));

            // Set into state
            setDataList(updatedList);

        } else {
            setTransDetail({ ...transDetail, [name]: value });
        }
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        // Ensure the date is formatted correctly
        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Always 'DD-MMM-YYYY'
        const updatedDates = { ...transDetail, [name]: updatedValue };
        setTransDetail(updatedDates);
    }
    const handleAmountChange = (e) => {
        const { name, value } = e.target;

        if (name === "amount") {
            if (value === "") {
                setAccountData({
                    ...accountdata,
                    [name]: "",
                    allocated: alocatedAmounts,
                    unAllocated: unAllocatedAmounts
                });
                return;
            }
            const numericValue = parseFloat(value) || 0;
            // If leaseNo or refNo is empty, show warning
            if (!leaseDetails.leaseNo?.value) {
                toast.warning("Please select Lease No first");
                return;
            }
            if (accountdata?.unAllocated <= 0) {
                toast.warning("UnAllocated amount must be greater than 0");
                return;
            }
            if (numericValue > alocatedAmounts) {
                toast.warning("Amount must be less than or equal to UnAllocated amount");
                return;
            }

            const newUnallocated = parseFloat((parseFloat(unAllocatedAmounts) - numericValue).toFixed(3));
            setAccountData({
                ...accountdata,
                [name]: value,
                allocated: numericValue + parseFloat(alocatedAmounts),
                unAllocated: newUnallocated === -0 ? 0 : newUnallocated
            });

        } else {
            setAccountData({ ...accountdata, [name]: value });
        }
    }

    // On first load or after new transaction input
    const initializeDataList = (list) => {
        return list?.map((item, index) => ({
            ...item,
            IsSelected: false,
            canEnable: index === 0 && parseFloat(item?.Balance) > 0
        }));
    }
    const handleClear = () => {
        setDataList([])
        setLeaseList([])
    }
    const HandleSave = async () => {
        setLoader(true);
        try {
            if (!transDetail?.accountDr?.label) {
                toast.warning("Please Select Debit Account")
                setLoader(false);
                return
            }
            if (transDetail?.transMethod?.label === "PDC" || transDetail?.transMethod?.label === "Cheque") {
                if (!transDetail?.checkNo) {
                    toast.warning('Please Enter Cheque No')
                    setLoader(false);
                    return;
                } else if (!transDetail?.checkDate) {
                    toast.warning('Please Enter Cheque Date ')
                    setLoader(false);
                    return;
                } else if (!transDetail?.drawnBank) {
                    toast.warning('Please Enter Drawn On Bank ')
                    setLoader(false);
                    return;
                }
            }
            if (transDetail?.amount <= 0) {
                toast.warning("Amount must be Greater then 0")
                setLoader(false);
                return;
            } else if (dataList?.length <= 0) {
                toast.warning('Please Select Lease No with Receiveable List')
                setLoader(false);
                return;
            } else if (accountdata.unAllocated > 0) {
                toast.warning('Please Allocate amount')
                setLoader(false);
                return;
            } else if (accountdata?.amount > 0) {
                if (!accountdata.accountNO?.value) {
                    toast.warning("Account must be selected for adjusted amount")
                    setLoader(false);
                    return
                }
            }
            const selectedItems = dataList?.filter(item => item.IsSelected);
            if (selectedItems[0].IsSelected === false) {
                toast.warning('Please Select Lease No with Receiveable List')
                setLoader(false);
                return;
            }
            for (const item of selectedItems) {
                if (item?.IsSelected === true) {
                    if (item.amount <= 0) {
                        toast.warning('Selected List amount should be Greater then 0')
                        setLoader(false);
                        return;
                    }
                }
            }
            handleSubmit()
        } catch (error) {
            setLoader(false)
            console.error('Error Save Data', error.error.res.message);
        }
    }
    const handleSubmit = async () => {
        try {
            setLoader(true);
            const params = new URLSearchParams();
            params.append('Action', 'CheckOperatingMonth');
            const formattedDate = moment(transDetail?.receiptDate).format('DD-MMM-YYYY');
            params.append('TaxDescription', formattedDate);
            const res = await apiService.getApiParamater('LEASE_NO_DATA', `?${params.toString()}`);
            let data = res?.data?.result?.data
            if (data?.length === 0) {
                toast.warning('Operating Month is Closed')
            } else if (data?.IsClosed === true) {
                toast.warning('Operating Month is Closed')
            } else {
                const receivablesIndex = [];
                const selectedItems = dataList?.filter(item => item.IsSelected);
                if (selectedItems?.length > 0) {
                    selectedItems.forEach(item => {
                        receivablesIndex.push({
                            select: item?.IsSelected,
                            isSelected: false,
                            recordId: item.RecordId || 0,
                            psdId: item.PSDId || 0,
                            groupId: item.GroupId || 0,
                            leaseNo: item.LeaseNo || "",
                            category: item.Category || "",
                            description: item.Description || "",
                            dueDate: moment(item?.DueDate).format(),
                            invoiceNo: item.InvoiceNo || "",
                            invoiceDate: item.InvoiceDate || "",
                            installmentAmount: item.InstallmentAmount || 0,
                            tax: item.Tax || "",
                            taxCode: item.TaxCode || 0,
                            taxInclusive: item.TaxInclusive || false,
                            vatPercent: item.VATPercent || 0,
                            vat: item.VAT || 0,
                            total: item?.Total.toString() || "0",
                            amountPaid: parseFloat(item.AmountPaid)?.toFixed(3) || 0,
                            amount: parseFloat(item.amount)?.toFixed(3) || 0,
                            balance: parseFloat(item.Balance)?.toFixed(3) || 0,
                            refNo: item.RefNo || "",
                            narration: item.Narration || "",
                            costCenter1: item.CostCenter1 || "",
                            costCenter2: item.CostCenter2 || "",
                            crAcCode: item.CrAcCode || "",
                            crAcName: item.CrAcName || "",
                            drAcCode: item.DrAcCode || "",
                            drAcName: item.DrAcName || "",
                            isSD: item.IsSD || false,
                            isOther: item.IsOther || false,
                            debitId: item.DebitId || 0,
                            outletName: "0",
                        });
                    });

                    // Add additional entry if conditions are met
                    if (accountdata?.amount > 0 && accountdata?.accountNO?.value && accountdata?.unAllocated === 0) {
                        const baseItem = selectedItems[0];
                        receivablesIndex.push({
                            select: true,
                            isSelected: false,
                            recordId: baseItem.RecordId || 0,
                            psdId: baseItem.PSDId || 0,
                            groupId: baseItem.GroupId || 0,
                            leaseNo: baseItem.LeaseNo || "",
                            category: baseItem.Category || "",
                            description: accountdata?.accountNO?.label || "",
                            dueDate: moment(baseItem?.DueDate).format(),
                            invoiceNo: "0",
                            invoiceDate: baseItem.InvoiceDate || "",
                            installmentAmount: 0,
                            tax: baseItem.Tax || "",
                            taxCode: baseItem.TaxCode || 0,
                            taxInclusive: baseItem.TaxInclusive || false,
                            vatPercent: baseItem.VATPercent || 0,
                            vat: baseItem.VAT || 0,
                            total: '0',
                            amountPaid: 0.000,
                            amount: parseFloat(accountdata?.amount)?.toFixed(3) || 0,
                            balance: 0.000,
                            refNo: baseItem.RefNo || "",
                            narration: baseItem.Narration || "",
                            costCenter1: baseItem.CostCenter1 || "",
                            costCenter2: baseItem.CostCenter2 || "",
                            crAcCode: accountdata.accountNO?.value?.value || "",
                            crAcName: accountdata.accountNO?.label || "",
                            drAcCode: baseItem.DrAcCode || "",
                            drAcName: baseItem.DrAcName || "",
                            isSD: baseItem.IsSD || false,
                            isOther: baseItem.IsOther || false,
                            debitId: baseItem.DebitId || 0,
                            outletName: "0",
                        });
                    }
                }
                let body = {
                    leasereceiptMain: {
                        iSeMail: sendEmail,
                        leaseDetails: {
                            leaseNo: leaseDetails?.leaseNo?.label,
                            property_No: leaseDetails?.property?.value?.value,
                            property_Name: leaseDetails?.property?.label,
                            unit_No: leaseDetails?.unitNo?.label,
                            periodFrom: moment(leaseDetails?.periodfrom).format(),
                            periodTo: moment(leaseDetails?.periodto).format(),
                            tenantNo: leaseDetails?.TenantNo,
                            tenantName: leaseDetails?.TenantName,
                            rent: leaseDetails?.rent.toString(),
                            contactNo: leaseDetails?.contactNo,
                            receiptNo: '0',
                            amount: transDetail?.amount.toString(),
                            refNo: transDetail?.reserveNo,
                            unallocatedAmount: accountdata?.unAllocated.toString(),
                            allocatedAmount: accountdata?.allocated.toString(),
                            account: "0",
                            outlet_Name: "0",
                            groupId: leaseDetails?.Group_Id
                        },
                        leaseReceipt: {
                            record_Id: "0",
                            tenantNo: leaseDetails?.TenantNo,
                            tenantName: leaseDetails?.TenantName,
                            groupId: leaseDetails?.Group_Id,
                            leaseNo: leaseDetails?.leaseNo?.label,
                            property_No: leaseDetails?.property?.value?.value,
                            property_Name: leaseDetails?.property?.label,
                            unit_No: leaseDetails?.unitNo?.label,
                            installment_Desc: "",
                            paymentMethod: transDetail?.transMethod?.label,
                            receiptType: transDetail?.receiptType?.label,
                            paymentDate: moment(transDetail?.receiptDate).format(),
                            receiptNo: "0",
                            chequeNo: transDetail?.checkNo,
                            drawnOnBank: transDetail?.drawnBank,
                            chequeDate: moment(transDetail?.checkDate).format() || "1900-01-01T15:45:02.707Z",
                            ccType: "",
                            ccNo: "",
                            ccExpiryDate: "1900-01-01T15:45:02.707Z",
                            installmentAmount: 0,
                            total: 0,
                            bankName: transDetail?.accountDr?.label,
                            bankAccount: transDetail?.accountDr.value.value,
                            payee: transDetail?.payee,
                            receiptDate: moment(transDetail?.receiptDate).format(),
                            amount: 0,
                            reverseRefNo: transDetail?.reserveNo,
                            narration: transDetail?.narration,

                            psdId: 0,
                            taxCode: 0,
                            vat: 0,
                            actualAmountToBePaid: 0,
                            actualAmountPaid: 0,
                            remainingAmount: "0",
                            accountCode: "0",
                            voucherNo: "0",
                            isTax: false,
                            isDeposit: false,
                            isAdditionalAmount: false,
                            isOtherReceipt: false,
                            isChequeCleared: false,
                            clearedDate: currentDatetimeUTC,
                            clearedBy: "0",
                            exp1: "0",
                            exp2: "0",
                            exp3: "0",
                            exp4: "0",
                            exp5: "0",
                            modifiedBy: Name,
                            modifiedOn: currentDatetimeUTC,
                            createdBy: Name,
                            createdOn: currentDatetimeUTC,
                            _payemntmethod: 0
                        },
                        receivablesIndex: receivablesIndex
                    }
                }

                const res = await apiService.post('CREATE_LEASE_RECEIPT', body);
                if (res?.data?.statusCode === 201) {
                    toast.success(res?.data?.message)
                    let resData = res?.data?.result
                    const token = localStorage.getItem("Token");
                    const DB = localStorage.getItem("DataBase")
                    if (!token) {
                        alert("Auth token is missing! Unable to proceed.");
                        return;
                    }
                    const popupWidth = 1000;
                    const popupHeight = 600;
                    const popupLeft = (window.screen.width - popupWidth) / 2;
                    const popupTop = (window.screen.height - popupHeight) / 2;
                    const popup = window.open(
                        "",
                        "ReportPopup",
                        `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                    );

                    if (popup) {
                        const form = document.createElement("form");
                        form.method = "POST";
                        form.action = REACT_APP_REPORTS
                        form.target = "ReportPopup";
                        const inputs = [
                            { name: "authToken", value: token },
                            { name: "_db", value: DB },
                            { name: "RecordId", value: "" },
                            { name: "LeaseNo", value: resData?.leaseNo },
                            { name: "ReceiptNo", value: resData?.receiptNo },
                            { name: "reportName", value: 'LEASEBULKRPT' },
                        ];

                        inputs.forEach(({ name, value }) => {
                            const input = document.createElement("input");
                            input.type = "hidden";
                            input.name = name;
                            input.value = value;
                            form.appendChild(input);
                        });

                        document.body.appendChild(form);
                        form.submit();
                        document.body.removeChild(form);
                    }
                    handleClearData()
                    navigate(`/Property/Management/Lease/Receipt/Listing`)
                    setLoader(false);
                } else {
                    toast.error(res?.data?.message)
                    setLoader(false);
                }
                setLoader(false);
            }
        } catch (error) {
            setLoader(false)
            console.error('Error Save Data', error.error.res.message);
        }
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-") {
            e.preventDefault();
        }
    }
    const handleAccountNoChange = (selectedOption) => {
        setAccountData({ ...accountdata, accountNO: selectedOption });
    }
    const handleClearData = () => {
        const selecteddabit = methods?.find(pro => pro?.text === "Bank Transfer");
        const selectedLease = receiptType?.find(pro => pro?.text === "Lease Receipt");
        setTransDetail({
            ...transDetail,
            transMethod: { label: selecteddabit?.text, value: selecteddabit },
            receiptType: { label: selectedLease?.text, value: selectedLease },
            checkNo: "",
            receiptDate: getCurrentLocalDatetime(),
            checkDate: getCurrentLocalDatetime(),
            amount: 0,
            drawnBank: "",
            accountDr: [{ label: null, value: null }],
            reserveNo: "",
            payee: "",
            narration: "",
        });
        setLeaseDetail(prev => ({
            unitNo: [{ label: null, value: null }],
            property: [{ label: null, value: null }],
            leaseNo: [{ label: null, value: null }],
            periodfrom: "",
            periodto: "",
            rent: "",
            TenantNo: "",
            TenantName: "",
            contactNo: "",
        }));
        setAccountData(prev => ({
            accountNO: [{ label: null, value: null }],
            amount: 0,
            refNo: "",
            allocated: 0,
            unAllocated: 0,
        }));
        setDataList([])
        setLeaseList([])
        setAloocated(0)
        setSendEmail(false)
        setUnAloocated(0)
        setUnitList([])
        setLoader(false);
    }
    return (
        <div className='p-5'>
            <div className='d-flex justify-contant-between'>
                <h5 className='col h5 '>Lease Receipt</h5>
                <div className='d-flex justify-content-end gap-1'>
                    {loader === true ?
                        <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button>
                        :
                        <button className='mainbtn ' onClick={HandleSave} type="submit"><FaSave className='center mt-1 mx-2' /> <div>Save</div></button>
                    }
                    <button className='mainbtnRed' onClick={handleClearData}><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                    <button onClick={handleBackClick} className='mainbtnSecondary'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            {/* Transection Details */}
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setTransTab(!transTab)}>
                    <div className='mainInvHead pt-1'>Transaction Details</div>
                </div>
                <div className={`slide-content ${transTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${transTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '20px' }}>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Transaction Method *</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    options={methods?.map((sup) => ({ value: sup, label: sup?.text }))}
                                    value={transDetail?.transMethod}
                                    onChange={(selectedOption) => handleMethodChange(selectedOption)}
                                    className="w-75 p-0"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">ChequeNo / Ref No</label>
                                <input type="text"
                                    value={transDetail?.checkNo}
                                    onChange={handleInputChange}
                                    name="checkNo"
                                    className="p-2 form-control w-75" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">ChequeDate / Ref Date</label>
                                <DatePicker
                                    selected={transDetail.checkDate ? new Date(transDetail.checkDate) : null}
                                    onChange={(date) => handleDateChange({ name: 'checkDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                    todayButton="Today"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">ReceiptType *</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    options={receiptType?.map((sup) => ({ value: sup, label: sup?.text }))}
                                    value={transDetail?.receiptType}
                                    onChange={(selectedOption) => handleTypeChange(selectedOption)}
                                    className="w-75 p-0"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="receiptDate" className="form-label pt-1 start">Receipt Date</label>
                                <DatePicker
                                    selected={transDetail.receiptDate ? new Date(transDetail.receiptDate) : null}
                                    onChange={(date) => handleDateChange({ name: 'receiptDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                    todayButton="Today"
                                />
                            </div>
                            {/* <div className="d-flex justify-content-between">
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">ReverseRefNo</label>
                                    <input type="text"
                                        value={transDetail?.reserveNo}
                                        onChange={handleInputChange}
                                        name="reserveNo"
                                        className="p-2 form-control w-75" />
                                </div>
                                <div className="form-check">
                                    <input
                                        style={{ width: "26px", height: "26px" }}
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={sendEmail}
                                        onChange={handleEmailChange}
                                    />
                                    <label className="form-check-label mx-2 mt-1">
                                        Send Email
                                    </label>
                                </div>
                            </div> */}
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">DrawnOnBank</label>
                                <input type="text"
                                    value={transDetail?.drawnBank}
                                    onChange={handleInputChange}
                                    name="drawnBank"
                                    className="p-2 form-control w-75" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Account(Dr) *</label>
                                <WindowedSelect
                                    className="w-75 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    value={transDetail.accountDr}
                                    onChange={(selectedOption) => handleAccountChange(selectedOption)}
                                    options={debitAccount?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Account No (Dr)</label>
                                <input type="text"
                                    value={transDetail?.accountDr?.value?.value || ''}
                                    // onChange={handleInputChange}
                                    name="payee"
                                    readOnly
                                    className="p-2 form-control w-75" />
                            </div>
                            {/* <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">payee</label>
                                <input type="text"
                                    value={transDetail?.payee}
                                    onChange={handleInputChange}
                                    name="payee"
                                    className="p-2 form-control w-75" />
                            </div> */}
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Amount</label>
                                <input type="number"
                                    value={transDetail?.amount}
                                    onChange={handleInputChange}
                                    name="amount"
                                    className="p-2 form-control w-75" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Narration</label>
                                <textarea type="text"
                                    value={transDetail?.narration}
                                    onChange={handleInputChange}
                                    name="narration"
                                    className="p-2 form-control w-100" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Lease Details */}
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='mainInvHead pt-1'>Lease Details</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '20px' }}>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Lease No *</label>
                                <WindowedSelect
                                    className="w-75 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    value={leaseDetails.leaseNo}
                                    onChange={(selectedOption) => handleLeaseNoChange(selectedOption)}
                                    options={leaseNo?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Property *</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-75 p-0"
                                    value={leaseDetails?.property}
                                    options={property?.map((sup) => ({ value: sup, label: sup?.text }))}
                                    onChange={(selectedOption) => handlePropertyNoChange(selectedOption)}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Unit No *</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-75 p-0"
                                    value={leaseDetails?.unitNo}
                                    options={unitList?.map((sup) => ({ value: sup, label: sup?.value }))}
                                    onChange={(selectedOption) => handleUnitNoChange(selectedOption)}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Period From</label>
                                <input type="text" className="p-2 form-control w-75" value={leaseDetails?.periodfrom} disabled />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Period To</label>
                                <input type="text" className="p-2 form-control w-75" value={leaseDetails?.periodto} disabled />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent</label>
                                <input type="text" className="p-2 form-control w-75" value={leaseDetails?.rent} disabled />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant No</label>
                                <input type="text" className="p-2 form-control w-75" value={leaseDetails?.TenantNo} disabled />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant</label>
                                <input type="text" className="p-2 form-control w-75" value={leaseDetails?.TenantName} disabled />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No</label>
                                <input type="text" className="p-2 form-control w-75" value={leaseDetails?.contactNo} disabled />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Receiveable */}
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setPaymentTab(!PaymentTab)}>
                    <div className='mainInvHead pt-1'>Receivables</div>
                </div>
                <div className={`slide-content ${PaymentTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 ${PaymentTab ? 'slide-in' : 'slide-out'}`}>
                        <div className='table-container' style={{ overflowX: 'auto', height: "auto" }}>
                            <table className='table table-bordered'>
                                <thead className='dynoTable'>
                                    <tr>
                                        <th>Select</th>
                                        <th>Description</th>
                                        <th>Due Date</th>
                                        <th>Invoice No</th>
                                        <th>Net Amount</th>
                                        <th>Paid Amount	</th>
                                        <th>Amount</th>
                                        <th>Balance</th>
                                        <th>CrAccName</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(dataList) && dataList?.map((data, index) => (
                                        <tr>
                                            <td className='m-0 p-0'>
                                                <div className="form-check pt-2">
                                                    <input
                                                        type="checkbox"
                                                        className='center'
                                                        style={{ height: '20px', width: '20px' }}
                                                        checked={data.IsSelected}
                                                        // disabled={!data.canEnable && index !== 0}
                                                        onChange={(e) => handleSelectChange(e, index)}
                                                    />

                                                </div>
                                            </td>
                                            <td className='m-0 p-0'><input value={data?.Description} className='p-1' disabled style={{ width: "auto" }} /></td>
                                            <td className='m-0 p-0'><input value={moment(data?.DueDate).format('DD-MMM-yyyy')} className='p-1' disabled style={{ width: "auto" }} /></td>
                                            <td className='m-0 p-0'><input value={data?.InvoiceNo} className='p-1' disabled style={{ width: "auto" }} /></td>
                                            <td className='m-0 p-0'><input value={data?.Total?.toFixed(3)} className='p-1' disabled style={{ width: "auto" }} /></td>
                                            <td className='m-0 p-0'><input value={data?.AmountPaid?.toFixed(3)} className='p-1' disabled style={{ width: "auto" }} /></td>
                                            <td className='m-0 p-0'><input value={Number(data?.amount || 0)?.toFixed(3) || "0.000"} className='p-1' disabled style={{ width: "auto" }} /></td>
                                            <td className='m-0 p-0'><input value={Number(data?.Balance || 0)?.toFixed(3) || "0.000"} className='p-1' disabled style={{ width: "auto" }} /></td>
                                            <td className='m-0 p-0'><input value={data?.CrAcName} className='p-1' disabled style={{ width: "auto" }} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className='border-box2 p-3'>
                <div className='row'>
                    <div className="col-6 d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start w-50">Amount (If any difference in Amount)</label>
                        <input type="number" className="p-2 form-control w-50"
                            onKeyDown={preventNegativeSign}
                            name='amount' value={accountdata?.amount} min={0} max={accountdata?.unAllocated}
                            onChange={handleAmountChange} />
                    </div>
                    <div className="col-3 d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start w-25">Ref No</label>
                        <input type="text" className="p-2 form-control w-75" name="refNo" value={accountdata?.refNo} onChange={handleAmountChange} />
                    </div>
                    <div className="col-3">
                        <div className="d-flex gap-3">
                            <h5 className="pt-1 start">UnAllocated Amount</h5>
                            <h5 className="pt-1">:</h5>
                            <h5 className="pt-1" onKeyDown={preventNegativeSign}>{Number(accountdata?.unAllocated || 0)?.toFixed(3) || "0.000"}</h5>
                        </div>
                        <div className="d-flex gap-3">
                            <h5 className="pt-1 start">Allocated Amount</h5>
                            <h5 className="pt-1">:</h5>
                            <h5 className="pt-1">{Number(accountdata?.allocated || 0)?.toFixed(3) || "0.000"}</h5>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-6 d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start w-50">Account</label>
                        <WindowedSelect
                            className="w-75 p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            menuShouldScrollIntoView={false}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                    color: '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000',
                                    },
                                }),
                            }}

                            value={accountdata?.accountNO}
                            onChange={(selectedOption) => handleAccountNoChange(selectedOption)}
                            options={
                                additional
                                    ?.slice(0, 50000)
                                    .map(rec => ({ value: rec, label: rec?.text }))
                            }
                        // options={TanentList?.map((rec) => ({ value: rec?.value, label: rec?.text }))}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default LeaseReceipt;